
import { Component, Prop, Mixins } from 'vue-property-decorator';
import LoadableMixin from '@/mixins/LoadableMixin';
import ModelMixin from '@/mixins/ModelMixin';
import { DeviceInfo, SharedDeviceInfo } from '@/types/device-info';
import { LMap, LTileLayer, LMarker, LControl, LPolyline, LIcon, LPopup, LPolygon } from 'vue2-leaflet';
import { HistoryData } from '@/types/history';
import { convertDateToReadable } from '@/utils/datetime';
import { fill } from '@/utils/location';

@Component({
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LControl,
        LPolyline,
        LIcon,
        LPopup,
        LPolygon,
    },
    mixins: [LoadableMixin, ModelMixin],
})
export default class ShareEditPopup extends Mixins<LoadableMixin, ModelMixin<SharedDeviceInfo>>(
    LoadableMixin,
    ModelMixin,
) {
    styles = 'height: 100%; z-index: 0';
    convertDateToReadable = convertDateToReadable;
    fill = fill;

    @Prop({ required: true })
    showModalMap!: boolean;

    zoom = 12;

    @Prop({ required: true })
    mapCenter!: number[];

    @Prop({ required: true })
    url!: string;

    @Prop({ required: true })
    polyline!: number[][];

    @Prop({ required: true, default: [] })
    locations!: HistoryData[];

    @Prop({ required: true, default: 10 })
    perPage!: number;

    @Prop({ required: true })
    device!: DeviceInfo;

    getTimeStamp(location: HistoryData) {
        if (!location.timeCreated && !location.timestamp) return 'N/A';
        let dateVal = location.timeCreated ? location.timeCreated : new Date((location.timestamp as number) * 1000);
        return convertDateToReadable(dateVal);
    }
}
